import Select, { type MenuPosition } from "react-select";

import { type KeyLabel } from "../../../graphql.js";
import { type IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";

/**
 * Operator select input for advanced search criteria.
 */
export default function AdvancedSearchOperator(props: IAdvancedSearchFieldProps & { menuPosition?: MenuPosition }) {
  const selectedOperator: KeyLabel =
    props.filterOperation &&
    props.field.searchAttribute.operators.find((operator: KeyLabel) => operator.key === props.filterOperation.operator);

  // TODO: A good idea would be to use the extracted "defaulted" component from the Advanced Search
  //       It has the same kind of default values and it will avoid duplicates
  return (
    <Select
      className={"react-select"}
      classNamePrefix={"react-select"}
      value={selectedOperator}
      getOptionValue={(option: KeyLabel) => option.key}
      placeholder={"Select operator"}
      options={props.field.searchAttribute.operators}
      isClearable={false}
      onChange={(operator: KeyLabel) => props.onChangeState({ operator: operator.key })}
      onBlur={props.onBlur}
      noOptionsMessage={() => "No results"}
      menuPosition={props.menuPosition ?? "fixed"}
      styles={{ menu: (base) => ({ ...base, zIndex: "999999 !important" as any }) }} // when clicking on the arrow, the date picker does not close, therefore it needs to be over bia the zIndex
    />
  );
}
